/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerRightDownIcon16Light = forwardRef('ArrowDCornerRightDownIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M10 4.5A2.5 2.5 0 0 0 7.5 2h-6a.5.5 0 0 0 0 1h6A1.5 1.5 0 0 1 9 4.5v8.293L5.354 9.146a.5.5 0 1 0-.708.708l3.652 3.651a1.7 1.7 0 0 0 2.404 0l3.652-3.651a.5.5 0 0 0-.708-.708L10 12.793V4.5Z" })));
});
